import { call, takeLatest, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import * as api from '@api/readerTask';
import { ReaderTasksListFetchAction } from './ReaderTasksList.types';
import { actions } from './ReaderTasksList.slice';
import { Resp, dispatch } from '../helpers';
import { ReaderTasksFilters } from '@dynamika-shared/types/readings.types';
import { selectAuthState } from '../auth/auth.slice';
import { mapUserRoleToTaskListEndpoint } from '../readerTaskOrchestration/workers/viewerModeMapper';

export function* ReaderTasksListFetchWorker({
  payload: { clinicalTrialId, filters, sort, page, size },
}: ReaderTasksListFetchAction): SagaIterator {
  try {
    const activeFilters: Partial<ReaderTasksFilters> = Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Object.entries({ ...filters, sort }).filter(([filterKey, value]) => value)
    );

    const authState = yield select(selectAuthState);
    const selectedRole = authState?.data?.selectedRole;
    const taskEndpoint = mapUserRoleToTaskListEndpoint(selectedRole);

    const response: Resp<typeof api.fetchReaderTasks> = yield call(
      api.fetchReaderTasks,
      clinicalTrialId,
      activeFilters,
      page,
      size,
      taskEndpoint
    );
    yield dispatch(actions.fetchReaderTasksListSuccess(response.data));
  } catch (e) {
    yield dispatch(actions.fetchReaderTasksListError(e as Error));
  }
}

export function* ReaderTasksListSaga() {
  yield takeLatest(
    actions.fetchReaderTasksList.type,
    ReaderTasksListFetchWorker
  );
}
